// Configuration de l'API
// BEST PRACTICE: Utiliser l'utilitaire centralisé pour éviter les erreurs de construction d'URL
import { getApiBaseUrl as getBaseUrl, buildApiUrl, buildApiUrlWithParams } from '../utils/apiUrl';

// Réexporter pour compatibilité avec le code existant
const getApiBaseUrl = getBaseUrl;

// Utiliser un getter pour que la détection se fasse au runtime
export const API_CONFIG = {
  get BASE_URL() {
    return getApiBaseUrl();
  },
  TIMEOUT: 10000,
};

// Endpoints de l'API
export const API_ENDPOINTS = {
  // ========== AUTH ==========
  LOGIN: '/users/auth/login/',
  LOGOUT: '/users/auth/logout/',
  FORGOT_PASSWORD: '/users/auth/forgot-password/',
  REFRESH_TOKEN: '/users/auth/refresh-token/',
  CURRENT_USER: '/users/me/',  // Corrigé: /users/current/ n'existe pas
  USER_PROFILE: '/users/me/',
  CHANGE_PASSWORD: '/users/change-password/',
  
  // ========== USERS ==========
  USERS: '/users/',
  
  // ========== DEPARTMENTS ==========
  DEPARTMENTS: '/users/departments/',
  DB_BACKUPS_FILES: '/users/db-backups/files/',
  DB_BACKUPS_JOBS: '/users/db-backups/jobs/',
  DB_BACKUPS_CREATE: '/users/db-backups/create_backup/',
  DB_BACKUPS_RESTORE: '/users/db-backups/restore_backup/',
  DB_BACKUPS_DOWNLOAD: '/users/db-backups/download/',
  
  // ========== DOCUMENTS ==========
  DOCUMENTS: '/documents/documents/',
  DOCUMENT_DOMAINS: '/documents/domains/',
  USECASE_TEMPLATES: '/documents/usecase-templates/',
  USECASE_TEMPLATE_DETAIL: (id: string | number) => `/documents/usecase-templates/${id}/`,
  USECASE_CATEGORIES: '/documents/usecase-categories/',
  USECASE_CATEGORY_DETAIL: (id: string | number) => `/documents/usecase-categories/${id}/`,
  
  // Actions sur documents
  DOCUMENT_DOWNLOAD: (id: string) => `/documents/documents/${id}/download/`,
  DOCUMENT_VIEW: (id: string) => `/documents/documents/${id}/view/`,
  DOCUMENT_TOGGLE_FAVORITE: (id: string) => `/documents/documents/${id}/toggle_favorite/`,
  
  // ========== PROJECTS ==========
  PROJECTS: '/projects/projects/',
  PROJECT_MY: '/projects/projects/my_projects/',
  TEAMS: '/projects/teams/',
  
  // Actions sur projets
  PROJECT_DOCUMENTS: (id: string) => `/projects/projects/${id}/documents/`,
  PROJECT_ADD_DOCUMENT: (id: string) => `/projects/projects/${id}/add_document/`,
  PROJECT_REMOVE_DOCUMENT: (id: string) => `/projects/projects/${id}/remove_document/`,
  PROJECT_ADD_MEMBER: (id: string) => `/projects/projects/${id}/add_member/`,
  PROJECT_REMOVE_MEMBER: (id: string) => `/projects/projects/${id}/remove_member/`,
  
  // Actions sur équipes
  TEAM_ADD_MEMBER: (id: string) => `/projects/teams/${id}/add_member/`,
  TEAM_REMOVE_MEMBER: (id: string) => `/projects/teams/${id}/remove_member/`,
  
  // ========== SEARCH ==========
  SEARCH: '/search/search/search/',
  
  // ========== PERMISSIONS ==========
  ROLES: '/permissions/roles/',
  USER_ROLES: '/permissions/user-roles/',
  USER_ROLE_SET: '/permissions/user-roles/set_role/',
  PERMISSION_GROUPS: '/permissions/permission-groups/',
  USER_PERMISSIONS: '/permissions/user-permissions/',
  PERMISSIONS: '/permissions/permissions/',
  PERMISSION_MATRIX: '/permissions/matrix/',
  MY_PERMISSIONS: '/permissions/me/',
  ACCESS_LOGS: '/permissions/access-logs/',
  // Actions permissions
  ROLE_PERMISSIONS: (id: string) => `/permissions/roles/${id}/permissions/`,
  ROLE_ASSIGN_PERMISSIONS: (id: string) => `/permissions/roles/${id}/assign_permissions/`,
  ROLE_CAPABILITIES: (id: string) => `/permissions/roles/${id}/capabilities/`,
  ROLE_SYNC: (id: string) => `/permissions/roles/${id}/sync/`,
  ROLE_USERS: (id: string) => `/permissions/roles/${id}/users/`,

  // ========== NOTIFICATIONS ==========
  NOTIFICATIONS: '/notifications/notifications/',
  NOTIFICATIONS_UNREAD_COUNT: '/notifications/notifications/unread_count/',
  NOTIFICATIONS_MARK_READ: '/notifications/notifications/mark_read/',
  NOTIFICATIONS_MARK_ALL_READ: '/notifications/notifications/mark_all_read/',
};

// Types de réponse API
export interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: string;
  message?: string;
}

export interface PaginatedResponse<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

// Helper pour construire les URLs correctement
// BEST PRACTICE: Utiliser l'utilitaire centralisé
export const buildUrl = buildApiUrlWithParams;

// Helper pour gérer les erreurs API
export const handleApiError = (error: any): string => {
  if (error.response) {
    // Erreur de réponse du serveur
    return error.response.data?.message || error.response.data?.error || 'Erreur serveur';
  } else if (error.request) {
    // Pas de réponse du serveur
    return 'Impossible de contacter le serveur';
  } else {
    // Erreur lors de la configuration de la requête
    return error.message || 'Erreur inconnue';
  }
};

export default API_CONFIG;
